import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';
import React from 'react';

type ConfirmationDialogProps = DialogProps & {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  confirmText?: string | React.ReactNode;
  cancelText?: string;
  renderChildren?: () => React.ReactNode;
  message?: string | React.ReactNode;
  color?: 'primary' | 'error' | 'success';
  cancelButtonProps?: React.ComponentProps<typeof Button>;
  confirmButtonProps?: React.ComponentProps<typeof Button>;
};

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  renderChildren,
  cancelText,
  confirmText,
  color,
  title,
  onClose,
  onConfirm,
  message,
  cancelButtonProps,
  confirmButtonProps,
  ...props
}) => {
  return (
    <Dialog open={open} onClose={onClose} {...props}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
        {renderChildren ? renderChildren() : null}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
          color={color}
          {...cancelButtonProps}
        >
          {cancelText || 'Cancel'}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          variant="contained"
          color={color}
          {...confirmButtonProps}
        >
          {confirmText || 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
